<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="responsiveHeaders"
      :items="games"
      hide-default-footer
      mobile-breakpoint="321"
      @click:row="onRowClicked"
      :items-per-page="1000"
      :sort-by.sync="sortBy"
    >
      <template v-slot:item.type="{ item }">
        <v-badge
          color="accent"
          :overlap="true"
          :value="item.yourUnreadChatMessages ? item.yourUnreadChatMessages > 0 : false"
          :content="item.yourUnreadChatMessages"
        >
          <multi-icon
            :icon="getGameTypeIcon(item.type)"
            :rightTopIcon="item.youAreParticipating === true ? 'mdi-check-circle' : null"
            :rightTopIconColor="'var(--v-success-base)'"
            :rightBottomIcon="getPlatformIcon(item.platform)"
            :rightBottomIconColor="'var(--v-secondary-base)'"
          />
        </v-badge>
      </template>
      <template v-slot:item.name="{ item }">
        <div v-if="item.portals">
          <div v-for="portal in item.portals" v-bind:key="portal.uid">
            <span class="portal caption">{{portal.name}}</span>
          </div>
        </div>
        <span>{{item.name}}</span>
        <div>
          <span class="caption text--secondary">{{getGameName(item.game)}}</span>
        </div>
        <div v-if="item.prizes && item.prizes.length > 0">
          <span class="text--secondary">
            <prizes-summary-widget :showHeader="false" :prizes="item.prizes"/>
          </span>
        </div>
        <div v-if="item.participationCoinFee > 0">
          <span class="text--secondary">
            {{$t('common.participation-fee')}}: <coins-widget :amount="item.participationCoinFee"></coins-widget>
          </span>
        </div>
      </template>
      <template v-slot:item.startsAt="{ item }">
        <span>{{$datefns.formatRelativeWithTime(item.startsAt)}}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import gameMixin from "@/mixins/gameMixin";
import commonMixin from "@/mixins/commonMixin";
import platformMixins from "@/mixins/platformMixins";
import gameTypeMixin from "@/mixins/gameTypeMixin";
import PrizesSummaryWidget from './prize/PrizesSummaryWidget.vue';
import CoinsWidget from './CoinsWidget.vue';

export default {
  name: "GameListPublic",
  mixins: [commonMixin, platformMixins, gameMixin, gameTypeMixin],
  components: {PrizesSummaryWidget, CoinsWidget},
  props: {
    games: {
      type: Array,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      sortBy: "startsAt",
      headers: [
        {
          text: "",
          align: "center",
          sortable: false,
          class: "typeCol",
          value: "type",
          width: "1.2em"
        },
        {
          text: this.$t('common.name'),
          sortable: false,
          value: "name",
        },
        {
          text: this.$t('competition.startDate'),
          sortable: true,
          value: "startsAt",
        },
      ]
    };
  },
  computed: {
    responsiveHeaders() {
      return this.headers;
    }
  },
  methods: {
    onRowClicked(game) {
      this.$router.push("/competitions/public/" + encodeURIComponent(game.uid));
    }
  }
};
</script>
